import { InvoicingMode } from '../types';


export const containerTypeKeyLabelMap = {
    BALE: "Bale",
    BOX: "Box",
    CARTON: "Carton",
    DRUM: "Drum",
    OVAL_ROLL: "Oval Roll",
    PALLET: "Pallet",
    ROLL: "Roll",
    FLAT_RACK: "Flat Rack",
    HEAVY_DUTY: "Heavy Duty",
    ISO_TANKS: "Iso Tanks",
    OPEN_TOP: "Open Top",
    REFRIGERATED: "Refrigerated",
    STANDARD: "Standard",
    IBC: "IBC",
    FLEXI: "Flexi",
    OTHER: "Other",
};


export const containerTypesByMode: Record<InvoicingMode, (keyof typeof containerTypeKeyLabelMap)[]> = {
  AIR: ['BALE', 'BOX', 'CARTON', 'DRUM', 'OVAL_ROLL', 'PALLET', 'ROLL', 'OTHER'],
  AIRCARGO: ['BALE', 'BOX', 'CARTON', 'DRUM', 'OVAL_ROLL', 'PALLET', 'ROLL', 'OTHER'],
  FCL: ['FLAT_RACK', 'HEAVY_DUTY', 'ISO_TANKS', 'OPEN_TOP', 'REFRIGERATED', 'STANDARD'],
  LCL: ['BOX', 'DRUM', 'IBC', 'OVAL_ROLL', 'PALLET', 'ROLL', 'OTHER'],
  RPTL: ['BOX', 'DRUM', 'IBC', 'OVAL_ROLL', 'PALLET', 'ROLL', 'OTHER'],
};
